import { BaseComponentState } from 'game-ui-types'
import { create } from 'zustand'

export interface ComponentStoreState extends BaseComponentState {
    setComponentStates: (newStates: Partial<BaseComponentState>) => void
    isExternalUIComponentActive: boolean
    setIsExternalUIComponentActive: (value: boolean) => void
}

export const useComponentStatesStore = create<ComponentStoreState>((set) => ({
    isBuyBonusComponentActive: false, // change this to true in order to activate the buy bonus and free buy bonus
    isComplianceComponentActive: true,
    isDoubleChanceButtonComponentActive: false,
    isJackpotCardsComponentActive: true,
    isPlayerInfoComponentActive: true,
    isMainButtonsComponentActive: true,
    isInfoLineComponentActive: true,

    setComponentStates: (newStates: Partial<BaseComponentState>) => {
        set((states) => ({ ...states, ...newStates }))
    },

    isExternalUIComponentActive: true,
    setIsExternalUIComponentActive: (value) => set({ isExternalUIComponentActive: value }),
}))
